import { useEffect, useRef, useState } from 'react'
import { CaratteristichePadreNode } from '@gql/graphql'
import { useTrans } from '@hooks/.'
import { ChevronDown, ChevronUp } from '@components/icons'
import { DownloadLink, WImage } from '@components/atoms'
import styles from './GridCertificationCard.module.sass'

interface Props {
  certificazione?: CaratteristichePadreNode
  className?: string
}

const GridCertificationCard = (props: Props) => {
  const { certificazione = undefined, className = '' } = props

  const t = useTrans()

  const [open, setOpen] = useState(false)
  const [height, setHeight] = useState<number | undefined>(undefined)
  const hiddenContentRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!hiddenContentRef.current) return

    const updateHeight = () => {
      const newHeight = open ? hiddenContentRef.current?.scrollHeight : 0
      setHeight(newHeight)
    }

    updateHeight()
    // Update height on window resize
    window.addEventListener('resize', updateHeight)
    return () => window.removeEventListener('resize', updateHeight)
  }, [open, hiddenContentRef])

  return (
    <div className={`${styles.root} ${className} ${open ? styles['root--open'] : ''}`}>
      <div className={styles.layout}>
        {certificazione?.logo && (
          <div className={styles.imageBox}>
            <WImage
              src={certificazione?.logo}
              maxWidth={110}
              maxHeight={110}
              objectFit="cover"
              alt={certificazione?.title}
              title={certificazione?.title}
            />
          </div>
        )}
        {!!certificazione?.title && <p className={styles.title}>{certificazione.title}</p>}
        <div
          className={styles.hiddenContent}
          ref={hiddenContentRef}
          id={`gridcertificationcard${certificazione.id}_panel`}
          aria-labelledby={`gridcertificationcard${certificazione.id}_label`}
          style={{ height: height !== undefined ? `${height}px` : undefined }}
        >
          <div className={styles.hiddenContentInner}>
            {certificazione?.descrizione && (
              <div
                className={styles.description}
                dangerouslySetInnerHTML={{ __html: certificazione.descrizione }}
              />
            )}
            {(!!certificazione.children?.length ||
              (!!certificazione.url && !!certificazione.title)) && (
              <div className={styles.fileList}>
                {!!certificazione.url && !!certificazione.title && (
                  <DownloadLink
                    item={{
                      pk: certificazione.id,
                      name: certificazione.title,
                      url: certificazione.url,
                    }}
                    className={styles.fileItem}
                  />
                )}
                {certificazione.children?.map((file, index) => (
                  <DownloadLink
                    item={{ pk: file.pk, name: file.title, url: file.url }}
                    key={index}
                    className={styles.fileItem}
                  />
                ))}
              </div>
            )}
          </div>
        </div>
        <button
          className={styles.trigger}
          onClick={() => setOpen((prev) => !prev)}
          id={`gridcertificationcard${certificazione.id}_label`}
          aria-expanded={open}
          aria-controls={`gridcertificationcard${certificazione.id}_panel`}
        >
          {t('Info e Download')}
          <span className={styles.icon}>{open ? <ChevronUp /> : <ChevronDown />}</span>
        </button>
      </div>
    </div>
  )
}

export default GridCertificationCard
